export default function Notices() {
  return (
    <div>
      All notices under this Contract for Services shall be in writing.
      <br /><br />
      Notices shall be deemed to have been duly given:
      <br /><br />
      <ul>
        <li>when delivered, if delivered by courier or other messenger (including registered mail) during normal business hours of the recipient;</li>
        <li>when sent, if transmitted by fax or e-mail and a successful transmission report or return receipt is generated;</li>
        <li>on the fifth business day following mailing, if mailed by national ordinary mail, postage prepaid;</li>
        <li>on the tenth business day following mailing, if mailed by airmail, postage prepaid.</li>
      </ul>
      <br /><br />
      In each case notices should be addressed to the most recent address, e-mail address, or facsimile number notified to the other Party.
    </div>
  );
}
